import {
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxCollection,
  RxDocument,
  RxJsonSchema,
  toTypedRxJsonSchema,
} from 'rxdb'

export const packHeaderSchemaLiteral = {
  title: 'Pack Header Schema',
  description: 'Describes a pack header',
  version: 0,
  keyCompression: false,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    name: {
      type: 'string',
    },
    image: {
      type: 'string',
    },
  },
  required: ['id', 'name', 'image'],
  indexes: [],
} as const

const schemaTyped = toTypedRxJsonSchema(packHeaderSchemaLiteral)

export type PackHeaderDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>

export const packHeaderSchema: RxJsonSchema<PackHeaderDocType> = schemaTyped

export type PackHeaderDocMethods = {
  test: () => void
}

export const packHeaderDocMethods = {
  test: () => null,
}

export type PackHeaderDocument = RxDocument<PackHeaderDocType, PackHeaderDocMethods>

export type PackHeaderCollectionMethods = {
  test: () => void
}

export type PackHeaderCollection = RxCollection<PackHeaderDocType, PackHeaderDocMethods, PackHeaderCollectionMethods>
